import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Link } from 'react-router-dom';
// import ExperienceClass from './ExperienceClass'; //旧的体验中心
import {
  AdvModelOne,
  AdvModelTwo,
  AdvModelThree,
  AdvModelFour,
  AdvModelFive,
  BannerModelOne,
  BannerModelTwo,
  BannerModelThree,
  BannerModelFour,
  BannerModelFive,
} from './model';

export class HomeContent extends Component {
  static propTypes = {
    homeModelList: PropTypes.object,
    actions: PropTypes.object.isRequired,
  };
  state = {
    disciplineList: [],
    freeDisciplineList: [], //体验中心分类
  };
  componentDidMount() {
    this.props.actions.fetchHomeModelList().then(res => {
      if (res.data.SuccessResponse) {
        const { modularlist } = res.data.Data;
        modularlist.forEach(item => {
          if (item.TemplateTypes === 1) {
            //存在体验中心
            //请求体验中心分类
            this.props.actions.fetchGetFreeClassification().then(res => {
              if (res.SuccessResponse) {
                this.setState({
                  freeDisciplineList: res.Data,
                });
              }
            });
          }
        });
      }
    });
    this.props.actions.fetchGetHaveCourseListDiscipline().then(res => {
      if (res.SuccessResponse) {
        this.setState({
          disciplineList: res.Data,
        });
      }
    });
  }
  onShowModelList(item) {
    switch (item.DefaultID) {
      case 1:
        return <AdvModelOne model={item} />;
      case 2:
        return <AdvModelTwo model={item} />;
      case 3:
        return <AdvModelThree model={item} />;
      case 4:
        return <AdvModelFour model={item} />;
      case 100:
        return <AdvModelFive model={item} />;
      case 5:
        return <BannerModelOne model={item} />;
      case 6:
        return <BannerModelTwo model={item} />;
      case 7:
        return <BannerModelThree model={item} />;
      case 8:
        return <BannerModelFour model={item} />;
      case 9:
        return <BannerModelFive model={item} />;
      default:
        return '';
    }
  }
  render() {
    const { homeModelList } = this.props;
    const { disciplineList, freeDisciplineList } = this.state;
    const modelList = homeModelList ? homeModelList.modularlist : [];
    let _disciplines = [],
      _freeDiscipline = [];
    if (disciplineList) {
      if (disciplineList.length > 10) {
        _disciplines = disciplineList.slice(0, 10);
      } else {
        _disciplines = disciplineList;
      }
    }

    return (
      <div className="home-home-content">
        {modelList &&
          modelList.length > 0 &&
          modelList.map((item, key) => {
            if (item.TemplateTypes === 1) {
              //体验中心模板
              item.Coursedetaillist.forEach(it => {
                it.TemplateTypes = 1;
                it.pushTo = this.props.history.push;
              });
              if (freeDisciplineList) {
                if (freeDisciplineList.length > 10) {
                  _freeDiscipline = freeDisciplineList.slice(0, 10);
                } else {
                  _freeDiscipline = freeDisciplineList;
                }
              }
              _disciplines = _freeDiscipline;
            }
            return (
              <div className={`home-model-item ${key % 2 ? 'bg_one' : 'bg_two'}`} key={key}>
                <div className="head-title-group">
                  <p className="tit">{item.Headline || '默认标题'}</p>
                  <ul>
                    {_disciplines.length > 0 &&
                      _disciplines.map((ele, key) => (
                        <li key={key}>
                          <Link
                            className="home-model-link"
                            to={`/courseList/${ele.ID}-0-0${
                              item.TemplateTypes === 1 ? '?typeName=tiyan' : ''
                            }`}
                            target="_blank"
                          >
                            {ele.Name}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
                {this.onShowModelList(item, key)}
              </div>
            );
          })}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    homeModelList: state.home.homeModelList,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContent);



// WEBPACK FOOTER //
// ./src/features/home/HomeContent.js